import { BellOff } from 'lucide-react';

import { Badge } from '@/components/ui/badge';

/**
 * A quiet incident: recorded like any other and announced to nobody — not when it
 * opens, escalates or resolves. Its severity badge still says how bad it is; this one
 * says nobody was told.
 */
export function QuietBadge() {
  return (
    <Badge
      variant="outline"
      className="gap-1 font-normal text-muted-foreground"
      title="Recorded without notifying anyone"
    >
      <BellOff className="size-3" aria-hidden />
      Quiet
    </Badge>
  );
}
